/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

import { mapGtmItem } from '../../api/mapping';

const liveSearchDataLayer = {
    /**
     * Dispatch custom event with data layer items
     *
     * @param items
     */
    dataLayerPushItems(items) {
        window.dispatchEvent(new CustomEvent("liveSearchProductsLoaded", {
            detail: {
                items: items.map(item => item.gtmItem || mapGtmItem(item))
            }
        }));
    }
}

export default liveSearchDataLayer;
